import { gql } from '@apollo/client'
import { SIMPLE_PRODUCT_FRAGMENT } from './SimpleProductFragment'
import { DISPLAY_AUDIT_IMAGE_FRAGMENT } from './DisplayAuditImageFragment'
import { USER_FRAGMENT } from './UserFragment'

export const FLAGGABLE_OBJECT_FRAGMENT = gql`
  fragment FlaggableObject on FlaggableObject {
    flagged {
      level
      reason
      reasonType
      moreInfo
      flaggedBy {
        ...User
      }
      levelRaisedBy {
        ...User
      }
      date
    }
    ... on DisplayAuditImage {
      ...DisplayAuditImage
    }
    ... on Product {
      ...SimpleProduct
    }
  }
  ${USER_FRAGMENT}
  ${DISPLAY_AUDIT_IMAGE_FRAGMENT}
  ${SIMPLE_PRODUCT_FRAGMENT}
`
